"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticate = authenticate;
exports.authenticateEmailRequired = authenticateEmailRequired;
exports.authenticateEmailTaken = authenticateEmailTaken;
exports.authenticateError = authenticateError;
var _events = require("../../types/events");
var _view = require("../../types/view");
var _sentEmail = require("../../types/sentEmail");
var _social = require("../../types/social");
var _action_types = require("../../constants/action_types");
var _jsonpRequest = require("../../../browser/utils/jsonpRequest");
var _view2 = require("../view");
var _tracking = require("../../utils/tracking");
var _validate = require("../../repositories/social-users/v1/validate");
function authenticate(parameters) {
  const {
    socialType,
    socialLoginId,
    email,
    token,
    userCreated,
    source
  } = parameters;
  return (dispatch, _getState, context) => {
    dispatch({
      type: _action_types.SOCIAL_AUTHENTICATE_TYPE,
      status: _social.EAuthenticateStatus.Loading
    });
    (0, _validate.fetchValidate)({
      httpApi: context.httpApi,
      parameters: {
        socialLoginId,
        email,
        token
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
          withCredentials: true
        }
      }
    }).then(response => {
      if (response.statusCode === 200) {
        const login = response.response.login;
        const logOnInfo = response.response.logOnInfo || [];
        Promise.all(logOnInfo.map(info => (0, _jsonpRequest.jsonpRequest)(`${info.logOnUrl}?` + `login=${encodeURIComponent(login)}&` + `token=${info.token}`))).then(() => {
          dispatch({
            status: _social.EAuthenticateStatus.Succeed,
            type: _action_types.SOCIAL_AUTHENTICATE_TYPE
          });
          if (userCreated) {
            dispatch((0, _view2.changeView)(_view.EActiveView.EmailSent, {
              type: _sentEmail.ESentEmailType.Registration,
              email
            }));
          }
          context.emitter.emit(_events.EEventType.SocialAuthenticateSucceed, {
            socialType,
            isNewUser: userCreated || false
          });

          //track success
          if (userCreated) {
            (0, _tracking.trackRegistrationSuccess)({
              socialType,
              source
            });
          } else {
            (0, _tracking.trackAuthenticateSuccess)({
              socialType,
              source
            });
          }
        }).catch(() => {
          dispatch({
            type: _action_types.SOCIAL_AUTHENTICATE_TYPE,
            status: _social.EAuthenticateStatus.Failed,
            errorType: _social.EAuthenticateError.Unexpected,
            error: 'Произошла непредвиденная ошибка'
          });
        });
        return;
      }
      const error = response.response.errors.length > 0 ? response.response.errors[0].message : response.response.message;
      dispatch({
        type: _action_types.SOCIAL_AUTHENTICATE_TYPE,
        status: _social.EAuthenticateStatus.Failed,
        errorType: _social.EAuthenticateError.Common,
        error
      });
    }).catch(error => {
      context.logger.error(error, {
        domain: 'auth-widget.api.socialAuthenticate',
        socialType
      });
      dispatch({
        type: _action_types.SOCIAL_AUTHENTICATE_TYPE,
        status: _social.EAuthenticateStatus.Failed,
        errorType: _social.EAuthenticateError.Unexpected,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function authenticateError(_type) {
  return dispatch => {
    dispatch({
      type: _action_types.SOCIAL_AUTHENTICATE_TYPE,
      status: _social.EAuthenticateStatus.Failed,
      errorType: _social.EAuthenticateError.Unexpected,
      error: 'Произошла непредвиденная ошибка'
    });
  };
}
function authenticateEmailTaken(parameters) {
  const {
    email,
    socialType,
    socialLoginId
  } = parameters;
  return (dispatch, _getState, context) => {
    dispatch({
      type: _action_types.SOCIAL_AUTHENTICATE_TYPE,
      status: _social.EAuthenticateStatus.Failed,
      errorType: _social.EAuthenticateError.EmailTaken,
      error: 'Необходимо объединить аккаунты',
      email,
      socialType,
      socialLoginId
    });
    dispatch((0, _view2.changeView)(_view.EActiveView.SocialMerge));
    context.emitter.emit(_events.EEventType.SocialAuthenticateEmailTaken, {
      type: socialType
    });
  };
}
function authenticateEmailRequired(parameters) {
  const {
    socialType,
    socialLoginId,
    email,
    phone
  } = parameters;
  return (dispatch, _getState, context) => {
    dispatch({
      type: _action_types.SOCIAL_AUTHENTICATE_TYPE,
      status: _social.EAuthenticateStatus.Failed,
      errorType: _social.EAuthenticateError.EmailRequired,
      error: 'Необходимо указать email',
      socialType,
      socialLoginId,
      email,
      phone
    });
    dispatch((0, _view2.changeView)(_view.EActiveView.SocialCreate));
    context.emitter.emit(_events.EEventType.SocialAuthenticateEmailRequired, {
      type: socialType
    });
  };
}